<template>
  <div>
    <loading-dialog
      :isButtonDisabled="!isComplete"
      @complete="onComplete"
      v-model="showDialog"
      :loadingValue="loadingValue"
      :customLogo="customLogo"
    >
      <template slot="title" v-if="!isComplete && loadingTitleText">{{
        loadingTitleText
      }}</template>
      <template slot="title" v-else>{{ cardTitle }}</template>
      <template slot="subtitle" v-if="!isComplete && loadingText">{{ loadingText }}</template>
      <template slot="subtitle" v-else>{{ saveText || cardText }}</template>
      <template slot="button"
        ><span v-if="nextRoute">{{ buttonText }}</span>
        <v-progress-circular indeterminate v-if="!nextRoute"></v-progress-circular
      ></template>
    </loading-dialog>
  </div>
</template>

<script>
import LoadingDialog from '../components/LoadingDialog.vue';
import { onLogout } from '../vue-apollo';

export default {
  name: 'RegisterComplete',
  props: {
    customLogo: String,
  },
  data() {
    return {
      nextRoute: null,
      showDialog: true,
      thankyouDialog: true,
      /* tenant customizable options */
      buttonText: this.$t('registration.registerComplete.buttonText'),
      clickToContinue: true,
      cardText: this.$t('registration.registerComplete.cardText'),
      cardTitle: this.$t('registration.registerComplete.cardTitle'),
      loadingText: null,
      loadingTitleText: null,
      init: null,
      /* should the store be reset after this component completes */
      isEndOfRegistration: true,
      checkForExistingUser: false,
      sendNotification: true,
      onSuccess: () => {},
    };
  },
  components: { LoadingDialog },
  computed: {
    isComplete() {
      return this.nextRoute;
    },
    memberId() {
      return this.$store.state.registration.memberId;
    },
    saveText() {
      return this.$store.state.registration.saveText;
    },
    loadingValue() {
      return this.$store.state.loadingValue;
    },
  },
  methods: {
    async completeRegistration() {
      const { checkForExistingUser } = this;
      const nextRoute = await this.$store.dispatch('completeRegistration', {
        memberInfo: { email: this.$store.state.registration.patientData.email, password: null },
        currentRoute: this.$route.name,
        isEndOfRegistration: this.isEndOfRegistration,
        checkForExistingUser,
        sendNotification: this.sendNotification,
        setToken: !this.isEmbedded,
      });
      if (typeof this.onSuccess === 'function') this.onSuccess();
      if (this.isEndOfRegistration && !this.isEmbedded) {
        this.$store.commit('resetRegistration');
        this.$store.commit('restoreSession');
        await onLogout();
      }
      if (nextRoute) {
        this.nextRoute = nextRoute;
      }
      if (this.isPageflowV2) {
        this.nextRoute = true;
      }
      if (!this.clickToContinue) {
        this.onComplete();
      }

      return null;
    },
    getInitialState() {
      const config = this.$store.getters.getConfig(this.$options.name);
      if (!config) return;
      Object.keys(config).forEach((option) => {
        this[option] = config[option];
      });
    },
    onComplete() {
      /*
        TODO: eliminate isPageFlowV2 check once we have
        fully migrated over to pageflow 2.0 system
      */
      this.$store.commit('set', { loadingValue: 0 });
      if (this.isPageflowV2) {
        this.$emit('next');
      } else if (this.nextRoute) {
        this.$router.push({ name: this.nextRoute });
      }
    },
    setAttributes() {
      const { att } = this.$route.query;
      if (!att) return;
      const attributes = att.split('-');

      const currentAttributes = this.$store.state.registration.memberAttributes;
      const memberAttributes = [
        ...(Array.isArray(currentAttributes) ? currentAttributes : []),
        ...attributes,
      ];

      this.$store.commit('setRegistration', {
        memberAttributes,
      });
    },
  },
  async mounted() {
    if (!this.isPageflowV2) {
      this.getInitialState();

      this.$store.watch(
        (state) => state.registration.errors.registerError,
        (value) => {
          if (value) {
            this.$router.push({ name: this.$store.getters.previousFlowRoute(this.$route.name) });
          }
        }
      );
    }
    this.setAttributes();
    this.$store.commit('setRegistration', { errors: { registerError: false } });

    this.$nextTick(async () => {
      await this.completeRegistration();
    });
  },
};
</script>
